import { ROUTER } from '../helpers/RouterApi';
import { BackEndHelper } from '../helpers/BackEndHelper';

export const BrokenUrlResultServices = {
    getList,
    approve
};

function getList() {
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_BROKENURLRESULT);
}

function approve(idfreeprofilesurl) {
    let data = {
        idfreeprofilesurl: idfreeprofilesurl,
      };
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_BROKENURLRESULT_APPROVE, data);
}